/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DashboardCert
 */
export interface DashboardCert {
    /**
     * 
     * @type {string}
     * @memberof DashboardCert
     */
    key?: string;
    /**
     * 
     * @type {string}
     * @memberof DashboardCert
     */
    chain?: string;
}

/**
 * Check if a given object implements the DashboardCert interface.
 */
export function instanceOfDashboardCert(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DashboardCertFromJSON(json: any): DashboardCert {
    return DashboardCertFromJSONTyped(json, false);
}

export function DashboardCertFromJSONTyped(json: any, ignoreDiscriminator: boolean): DashboardCert {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'key': !exists(json, 'key') ? undefined : json['key'],
        'chain': !exists(json, 'chain') ? undefined : json['chain'],
    };
}

export function DashboardCertToJSON(value?: DashboardCert | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'key': value.key,
        'chain': value.chain,
    };
}

